import React, { useState } from 'react'
import OutlinedButton from '../../../../../Containers/Home/components/OutlinedButton'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { CAMPAIGN_ENUM_TYPES_TO_TITLE } from '../../../../../shared/constants'

export const EmptyStateDropdownBtn = ({
  classes,
  handleCreateCampaign,
  campaignOptions,
}) => {
  const [openDropDown, setOpenDropDown] = useState(false)

  return (
    <div className={classes.campaignDropdownBtn}>
      <OutlinedButton
        alwaysActive={true}
        icon={openDropDown ? <RemoveIcon /> : <AddIcon />}
        disabled={false}
        onClick={() => {
          setOpenDropDown(!openDropDown)
        }}
        label="New Campaign"
        cypress_id={'newCampBtn'}
      />
      {openDropDown && (
        <div className={classes.newCampaignCTAOptionsWrapper}>
          {campaignOptions.map(option => (
            <p
              onClick={() => {
                handleCreateCampaign(option)
              }}
            >
              {CAMPAIGN_ENUM_TYPES_TO_TITLE[option.subtype || option.type]}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}
